// extracted by mini-css-extract-plugin
export var arrow = "Breadcrumbs-module--arrow--e7089";
export var crumb = "Breadcrumbs-module--crumb--326da";
export var cyan = "Breadcrumbs-module--cyan--24531";
export var orange = "Breadcrumbs-module--orange--89afc";
export var purple = "Breadcrumbs-module--purple--3235f";
export var red = "Breadcrumbs-module--red--f3b08";
export var root = "Breadcrumbs-module--root--0664f";